// extracted by css-extract-rspack-plugin
export default {"itemInner":"_3aa863fa","heartWrapper":"_73f03c48","heart":"_fb553c5b"};